// extracted by mini-css-extract-plugin
module.exports = {"cls1":"UserWorklistsPage-CssProp13_td-module--cls1--SbPqV","cls2":"UserWorklistsPage-CssProp13_td-module--cls2--1snRQ UserWorklistsPage-CssProp13_td-module--cls1--SbPqV"};